export default __webpack_public_path__ + "img/8f91ae82b701f74286695b8f4c97b62f.png";